import { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import Drawer, { DrawerHeader, DrawerFooter } from 'common/components/drawer';
import { FormDrawer } from 'common/components/drawer';
import { useForm, useActions } from 'utils/hooks';
import * as portActions from 'store/airports/actions';
import { strToNumber } from 'common/utils/numbers';
import { FormBody } from 'common/components/drawer';

import selectDataFromState from 'utils/selectDataFromState';

import config from './airport/config';
import Airport from './airport';

const EditAirport = ({ drawer, active, refetchData }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updateAirport, createAirport] = useActions([
    portActions.updateAirport,
    portActions.createAirport
  ]);
  const { formState, loadValues, handleSubmitError, resetForm, collectValues } = useForm(config);
  const { isOpen } = drawer;

  useEffect(() => {
    if (active && isOpen) {
      const params = {
        ...active
      };

      const initialValues = selectDataFromState(params, config);

      loadValues({
        ...initialValues,
        timezone: initialValues.timezone ?? null
      });
    }
    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  const submit = async () => {
    const values = collectValues();
    if (!values) return;

    const { country, lat, lon, airport_type, timezone, ...rest } = values;

    const params = {
      ...rest,
      country_code: country ? country.code : null,
      type: airport_type ? airport_type.label : null,
      timezone: timezone ?? null,
      lat: lat ? `${strToNumber(lat)}` : null,
      lon: lon ? `${strToNumber(lon)}` : null,
      id: active ? active.id : undefined
    };

    setIsSubmitting(true);

    try {
      if (active) {
        await updateAirport({ table: 'airports', ...params });
      } else {
        await createAirport({ table: 'airports', ...params });
        resetForm();
        refetchData();
      }

      drawer.close();
    } catch (error) {
      handleSubmitError(error);
    }

    setIsSubmitting(false);
  };

  return (
    <Drawer {...drawer} className="table-drawer" size="sm-md">
      <DrawerHeader className="border-bottom pb-4">
        {active ? 'Edit ' + active.name : 'Add New Airport'}
      </DrawerHeader>

      <FormDrawer>
        <FormBody>
          <Airport formState={formState} />
        </FormBody>
      </FormDrawer>

      <DrawerFooter className="d-flex justify-content-end p-3">
        <Button
          color="cancel"
          className="px-0 py-1 me-4"
          onClick={() => drawer.close()}
          disabled={isSubmitting}
        >
          CANCEL
        </Button>
        <Button onClick={submit} disabled={isSubmitting} color="primary" className="px-4">
          SAVE
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};

export default EditAirport;
